<template>
      <!-- Main -->
      <div>
        <vue-headful
          :title="$t('pages.home') + ' - Fernando Mata'"
        />

        
        <!-- Post -->
        <article class="post">
          <header>
            <div class="title" id="introduction">
              <h2>{{ $t('index.about') }}</h2>
              <p v-html="$t('index.headline')"></p>
            </div>
          </header>

          <div class="content">
            <ul class="feature-icons">
              <li v-for="(highlight) in highlights" :key="highlight.name" :class="iconName(highlight.fontIcon)" v-html=$t(localizedHighlight(highlight.descriptionKey))></li>
            </ul>
          </div>
        </article>
      </div>
</template>

<script>
import Highlights from '../data/Highlights.json'

export default {
  name: 'main',
  computed: {
    highlights() {
      return Highlights.sort(function (a, b) {
        return (a.position > b.position) ? 1 : (a.position < b.position) ? -1 : 0;
    })
    }
  },
  methods : {
    iconName(icon) {
      return "icon " + icon
    },
    localizedHighlight(key) {
      return "index.highlights." + key 
    }
  },
}
</script>
